define('views/wellness/activity',[
    'backbone',
    'views/_base/baseview',
    'text!views/wellness/activity.html',
], function(Backbone, BaseView, Template){
    'use strict';

    return BaseView.extend({
        tagName : 'li',
        isRender: true,
        template: _.template(Template),
        events  : {
            'click' : 'activityAction'
        },
        initialize: function(options){
            options = options || {};
            
            this.elementName = options.elementName;

            this.activity = (options.data) ? options.data : {};

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.$el.addClass(pf.getContent('wellness.content.accounts.item_class')).html(this.template());

            this.showActivityStatus();

            return this;
        },

        showActivityStatus: function(){

            if(this.activity.completed){

                var green_check_mark = pf.getContent('wellness.content.accounts.item_icon');
                this.$('.js-wellness-account-activity-status').html(green_check_mark);

                this.$el.addClass('completed');

            }

        },

        activityAction: function(e){
            if(e && e.preventDefault){ e.preventDefault(); }
            if(e && e.stopPropagation){ e.stopPropagation(); }

            console.log('activityAction',this);

        },

        close: function(){}
    });
});

